import React, { useState } from 'react';
import { Stack, Typography, IconButton, Box, Collapse } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { SxProps, Theme } from '@mui/material/styles';

interface CVSectionProps {
    title: string;
    children: React.ReactNode;
    sx?: SxProps<Theme>;
}

export const CVSection: React.FC<CVSectionProps> = ({ title, children, sx }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 4, mb: 2, ...sx }}>
                <Typography variant="h5">
                    {title}
                </Typography>
                <IconButton
                    onClick={() => setExpanded(!expanded)}
                    size="small"
                    sx={{ ml: 1 }}
                >
                    {expanded ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
            </Box>
            <Collapse in={expanded}>
                <Stack spacing={2}>
                    {children}
                </Stack>
            </Collapse>
        </>
    );
}; 